import React from 'react';
import ImageWrapper from '../ImageComponent/ImageWrapper';

/**
 * A reusable, premium success modal component.
 * 
 * @param {boolean} isOpen - Whether the modal is visible.
 * @param {function} onClose - Function to call when the modal is closed.
 * @param {string} title - The title of the success message.
 * @param {string} message - The detailed success message.
 * @param {string} buttonText - Text for the primary action button.
 * @param {function} onButtonClick - Function to call when the primary button is clicked.
 */
const SuccessModal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  buttonText, 
  onButtonClick 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all animate-in zoom-in slide-in-from-bottom-4 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-8 flex flex-col items-center text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6 animate-bounce-short">
            <svg 
              className="w-10 h-10 text-green-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2.5" 
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </div>
          
          <h3 className="text-2xl font-bold text-gray-900 mb-3 font-playfair">
            {title || "Success!"}
          </h3>
          
          <p className="text-gray-600 mb-8 leading-relaxed font-sans">
            {message || "Your request has been processed successfully."}
          </p>
          
          <button
            onClick={onButtonClick || onClose}
            className="w-full py-4 bg-BluntRed hover:bg-HoverModalButtonColor text-white font-semibold rounded-xl transition-all shadow-lg hover:shadow-BluntRed/30 active:scale-[0.98] uppercase tracking-wider text-sm"
          >
            {buttonText || "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
